import { NavLink, useLocation } from "react-router-dom";
import { Icon } from "@iconify/react";
import { NAVIGATION_ITEMS } from "../../utils/constants";
import useAuthStore from "../../store/useAuthStore";

// Routes that should keep a specific nav item active
const CHILD_ROUTES = {
  integrations: ["/website-scans"],
};

const Sidebar = ({ isOpen, onClose }) => {
  const { pathname } = useLocation();
  const { user } = useAuthStore();

  const isTeamMember = user?.role === "teamMember";
  const visibleNavigationItems = isTeamMember
    ? NAVIGATION_ITEMS.filter((item) =>
        ["integrations", "scan-planner", "settings"].includes(item.id),
      )
    : NAVIGATION_ITEMS;

  const isItemActive = (item, isActive) => {
    if (isActive) return true;
    return (CHILD_ROUTES[item.id] || []).some((route) =>
      pathname.startsWith(route),
    );
  };

  return (
    <>
      {/* Mobile/Tablet sidebar - hidden on lg screens and above */}
      <aside
        className={`fixed top-0 left-0 w-68 h-full bg-bg-sidebar border-r border-slate-800 text-text-primary p-4 flex flex-col overflow-y-auto shadow-2xl z-50 transform transition-transform duration-300 ease-in-out lg:hidden ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <div className="pb-6 border-b border-border mb-4">
          <div className="flex items-center justify-between mb-2">
            <img src="logo.png" alt="SentryPrime" className="h-8 w-auto" />
            <button
              onClick={onClose}
              className="p-2 text-slate-400 hover:text-white hover:bg-bg-sidebarSurface rounded-lg transition-colors"
              aria-label="Close menu"
            >
              <Icon icon="mdi:close" className="text-2xl" />
            </button>
          </div>
          <p className="text-xs text-[#60A4FA] text-center">
            Enterprise Dashboard
          </p>
        </div>

        <nav className="flex flex-col gap-1">
          {visibleNavigationItems.map((item) => (
            <NavLink
              key={item.id}
              to={item.path}
              onClick={onClose}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-3 text-sm font-medium rounded-lg transition-all duration-150 ${
                  isItemActive(item, isActive)
                    ? "bg-primary text-white"
                    : "text-slate-300 hover:bg-bg-sidebarSurface hover:text-white hover:translate-x-1"
                }`
              }
            >
              <Icon icon={item.icon} className="text-xl w-5 text-center" />
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>
      </aside>

      {/* Desktop sidebar - visible on lg, xl, and 2xl screens */}
      <aside className="hidden lg:flex w-64 bg-bg-sidebar border-r border-slate-800 text-text-primary p-4 flex-col fixed h-screen overflow-y-auto shadow-2xl z-50">
        <div className="space-y-4 pb-4 border-b border-border mb-4">
          <img src="logo.png" alt="SentryPrime" className="h-8 w-auto" />
          <p className="text-xs text-[#60A4FA] mt-1 text-center">
            Enterprise Dashboard
          </p>
        </div>

        <nav className="flex flex-col gap-1">
          {visibleNavigationItems.map((item) => (
            <NavLink
              key={item.id}
              to={item.path}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-3 text-sm font-medium rounded-lg transition-all duration-150 ${
                  isItemActive(item, isActive)
                    ? "bg-primary text-white"
                    : "text-slate-300 hover:bg-bg-sidebarSurface hover:text-white hover:translate-x-1"
                }`
              }
            >
              <Icon icon={item.icon} className="text-xl w-5 text-center" />
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>
      </aside>
    </>
  );
};

export default Sidebar;
